export const ITEMS_PP_OPTIONS = [
  {
    value: 12,
    label: '12',
  },
  {
    value: 30,
    label: '30',
  },
  {
    value: 60,
    label: '60',
  },
];

const getTotOptsBtTotPages = (totPages) => {
  if (totPages <= 5) return 0;
  if (totPages <= 10) return 1;
  if (totPages <= 15) return 2;
  if (totPages <= 20) return 3;
  return 4;
};

export const getGoToPageOptions = (pager = {}) => {
  const totPages = pager?.number_of_pages || 1;
  const totOpts = getTotOptsBtTotPages(totPages);
  const opts = [];
  for (let index = 1; index <= totOpts; index++) {
    const page = Math.floor((index * totPages) / (totOpts + 1));
    opts.push({
      value: page,
      label: `pag. ${page}`,
    });
  }
  return opts;
};
